import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'
import { mockFluidIntakeData } from './mockFluidIntakeData'

export type FluidIntakeTargetsParams = {
  residents: string | string[]
  to: any
  from: any
  fluidTrackingFlagEnabled: boolean
  mock?: boolean
}

export const useGetFluidIntaketargets = ({
  residents,
  to,
  from,
  fluidTrackingFlagEnabled,
  mock = false
}: FluidIntakeTargetsParams) => {
  const queryParams = getQueryParams({
    from: dayjs(from).local().format('YYYY-MM-DD'),
    to: dayjs(to).local().format('YYYY-MM-DD'),
    residents
  })

  const { isLoading, data, refetch } = useQuery(
    ['care-plan-fluid-intake-targets', residents, to, from],
    () =>
      getJSON({
        url: `/api/list/care-plans/fluid-intake-targets?${queryParams}`,
        headers: {
          'x-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      }),
    {
      enabled: fluidTrackingFlagEnabled && !mock
    }
  )

  if (mock) {
    return {
      fluidIntakeData: mockFluidIntakeData,
      isLoading: false,
      refetch: () => Promise.resolve()
    }
  }

  return {
    fluidIntakeData: data,
    isLoading,
    refetch
  }
}
